import { Box } from "@mui/material";
import React, { useEffect, useRef } from "react";
import ScrollableWrapper from "../../../../common/ScrollableWrapper";
import { todayISO } from "../../../shared/planDates";
import { sortedDays } from "../../helpers/activitySelectors";
import { useWorkoutPlan } from "../../store/useWorkoutPlan";
import WeekDayRow from "./WeekDayRow";

/**
 * Week view: one `WeekDayRow` per day the backend returned, Monday first
 * (mobile parity). When the week holds today, the list scrolls to that row.
 */
const WeekPlanView = () => {
  const { activeWeek } = useWorkoutPlan();
  const todayRef = useRef<HTMLDivElement>(null);
  const weekId = activeWeek?.monday;

  // After the week renders, bring today's row to the top of the list. Keyed
  // on the week so stepping back to this week scrolls again.
  useEffect(() => {
    todayRef.current?.scrollIntoView?.({ block: "start" });
  }, [weekId]);

  if (!activeWeek) return null;

  const today = todayISO();

  return (
    <ScrollableWrapper customPadding="8px">
      <Box sx={styles.list}>
        {sortedDays(activeWeek).map((day) => {
          const isToday = day.day === today;
          return (
            <WeekDayRow
              key={day.day}
              ref={isToday ? todayRef : undefined}
              day={day}
              services={activeWeek.services}
              isToday={isToday}
            />
          );
        })}
        <Box sx={{ height: "60px" }} />
      </Box>
    </ScrollableWrapper>
  );
};

export default WeekPlanView;

const styles = {
  list: {
    display: "flex",
    flexDirection: "column" as "column",
    gap: "16px",
  },
};
